import Embed from 'quill/blots/embed';
import { MentionItem } from '../../../core/models/mention-item.model';
import { MentionType } from '../../../core/enums/mention-type.enum';

export class MentionBlot extends Embed {
    static create(data: MentionItem) {
        const node = super.create() as any;
        const denotationChar = document.createElement('span');
        denotationChar.className = 'ql-mention-denotation-char';
        denotationChar.innerHTML = data.denotationChar;
        node.appendChild(denotationChar);
        node.innerHTML += data.value;
        node.setAttribute('data-mention-type', data.type === MentionType.group ? 'group' : 'user');
        node.setAttribute('data-mention-id', data.id);
        node.classList.add(data.type === MentionType.group ? 'mention-group' : 'mention-user');

        if (data.type === MentionType.user) {
            node.classList.add('user-info-link');
            node.setAttribute('userId', data.id);
        }
        return node;
    }
}

MentionBlot['blotName'] = 'mention';
MentionBlot['tagName'] = 'span';
MentionBlot['className'] = 'mention';
